<template>
  <div class="filterconfigurationpage">
    <div class="commonpageheader">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{name: 'Subscription'}">订阅管理</el-breadcrumb-item>
        <el-breadcrumb-item>数据过滤规则管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="filterbox">
      <div class="smallelform">
        <el-form size="small" label-width="70px">
          <el-row>
            <el-col :span="16">
              <el-form-item label="订阅名称">{{baseinfo.TaskName}}</el-form-item>
              <el-form-item label="TaskID">{{baseinfo.TaskID}}</el-form-item>            
            </el-col>
            <el-col :span="8">
              <el-popconfirm 
                v-if="showdelallbtn"
                confirm-button-text="确定" 
                cancel-button-text="取消" 
                title="确定清除全部杂质吗？" 
                @confirm="deleteAllNoise()"
              >
                <el-button size="mini" style="float: right;" type="danger" slot="reference">清除全部杂质</el-button>
              </el-popconfirm>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-form size="small" label-width="70px">
        <el-form-item label="过滤词">
          <input-tag :read-only="disabled3" :before-adding="trimTags" v-model="keyfilter" placeholder="每输入一个关键词按回车键确认"></input-tag>
        </el-form-item>
        <el-form-item label="保留词">
          <el-input :disabled="disabled3" v-model="keykeep" placeholder="用'|'表示或，用'&'表示和"></el-input>
        </el-form-item>
        <el-form-item v-if="!disabled3">
          <el-row>
            <el-col :span="16">
              <el-button type="primary" @click="hitData(0)" :plain="isplain0">保留</el-button>
              <el-button type="primary" @click="hitData(1)" :plain="isplain1">过滤</el-button>
            </el-col>
            <el-col :span="8" style="text-align:right;">
              <el-button style="margin-right:10px;" type="success" @click="saveFilterKeywords()">保存规则</el-button>
              <el-popconfirm 
                confirm-button-text="确定" 
                cancel-button-text="取消" 
                title="确定删除吗？" 
                @confirm="deleteNoise()"
              >
                <el-button type="danger" :disabled="!ischecked" slot="reference">清除杂质</el-button>
              </el-popconfirm>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
    </div>
    <div class="commontable">
      <div class="tablebox">
        <el-table 
          :cell-style="getCellStyle" 
          v-loading="loading" 
          :data="tablelist" 
          tooltip-effect="dark" 
          size="small" 
          @selection-change="handleSelectionChange"
          @sort-change="sortthiscolumn"
          :default-sort="defaultsort"
        >
          <el-table-column v-if="!disabled3" type="selection" width="50px"></el-table-column>
          <el-table-column prop="AssetID" label="AssetID" width="120px" show-overflow-tooltip></el-table-column>
          <el-table-column label="商品标题" show-overflow-tooltip>
            <template slot-scope="scope">
              <a :href="scope.row.AssetURL" target="_blank" v-html="scope.row.AssetTitle"></a>
            </template>
          </el-table-column>
          <el-table-column label="SKUMAP" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-html="scope.row.SkuMap"></span>
            </template>
          </el-table-column>
          <el-table-column sortable='custom' prop="Price" label="Price" width="100px"></el-table-column>
          <el-table-column prop="SkuId" label="SKUID" width="100px" show-overflow-tooltip></el-table-column>
        </el-table>
      </div>

      <div class="table-pagination table-pagination-left">
        <el-pagination
          small
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          popper-class="pagesizeclass"
          :page-sizes="[25, 50, 100]"
          :page-size="query.size"
          layout="total, prev, pager, next, sizes"
          :total="totalbrand"
        ></el-pagination>
        
        <div style="width:200px; float:right; text-align:right;">
          <el-button size="mini" style="margin-right:10px;" type="success" @click="saveFilterKeywords()">保存规则</el-button>
          <el-popconfirm 
            confirm-button-text="确定" 
            cancel-button-text="取消" 
            title="确定删除吗？" 
            @confirm="deleteNoise()"
          >
            <el-button size="mini" type="danger" :disabled="!ischecked" slot="reference">清除杂质</el-button>
          </el-popconfirm>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      query: {
        subid: this.$route.params.subid,
        filter: '',
        keep: '',
        page: 1,
        size: this.getLocalStorage('pagesize3') ? this.getLocalStorage('pagesize3') * 1 : 25,
        type: 0,
        order: ''
      },
      keyfilter: [],
      keykeep: '',
      baseinfo: {
        name: '',
        id: ''
      },
      currentPage: 1,
      tablelist: [],
      totalbrand: 0,
      keywords: "",
      isplain0: true,
      isplain1: true,
      ischecked: false,
      chklists: '',
      highlightkeywords: [],
      disabled1: this.getLocalStorage('level')/1 === 1 ? true : false,
      disabled3: this.getLocalStorage('level')/1 === 3 ? true : false,
      tableorder: '',
      defaultsort: {
        prop: 'Price',
        order: ''
      },
      showdelallbtn: this.getLocalStorage('level')/1 === 1
    };
  },

  mounted(){
    let that = this
    that.query.order = that.getLocalStorage('OrderFilter') != undefined ? that.getLocalStorage('OrderFilter') : ''
    if(that.query.order == 10){
      that.defaultsort.order = 'ascending'
    }
    if(that.query.order == 11){
      that.defaultsort.order = 'descending'
    }
    if(that.query.order == ''){
      that.defaultsort.order = null
    }
    that.getBaseInfo(function(){
      that.getTableList(that.query.type)
    })
  },

  methods: {

    getCellStyle({ column }) {
      // TODO 针对Safari表格width与showOverflowTooltip暂不能共存异常
      const tempWidth = column.realWidth || column.width
      if (column.showOverflowTooltip) {
        return {
          minWidth: tempWidth + 'px',
          maxWidth: tempWidth + 'px'
        }
      }

      return {}
    },

    /**
     * 切换每页显示条目数
     */
    handleSizeChange(val) {
      let that = this;
      that.currentPage = 1
      that.query.page = 1
      that.query.size = val
      that.setLocalStorage('pagesize3', val)
      that.getBaseInfo(function(){
        that.getTableList(that.query.type)
      })
    },

    /**
     * 切换分页
     */
    handleCurrentChange(val) {
      let that = this;
      that.query.page = val;
      that.getBaseInfo(function(){
        that.getTableList(that.query.type)
      })
    },

    /**
     * 选中数据行
     */ 
    handleSelectionChange(val) {
      let checkedlists = val
      let chks = []
      checkedlists.forEach(item => {
        chks.push(item.AssetID)
      })
      this.chklists = chks.join(',')
      if(chks.length > 0){
        this.ischecked = true
      }else{
        this.ischecked = false
      }
    },

    /**
     * 获取订阅基本信息
     */
    getBaseInfo: function(callback){
      let that = this
      let url = that.API_URL + '/sys/match/view'
      let query = {subid: that.query.subid}
      that.loading = true
      that.tablelist = []
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: query,
        success: function(data) {
          console.log('getBaseInfo', data)
          let info = data.results[0]
          that.baseinfo = info
          let fitlerstr = info.filter_txt
          let keepstr = info.keep_txt
          let newfilter
          if(fitlerstr === null || fitlerstr === ''){
            newfilter = that.keyfilter
          }else{
            newfilter = fitlerstr.indexOf('|') === -1 ? new Array(fitlerstr) : fitlerstr.split('|')
          }
          let newkeep
          if(keepstr === null || keepstr === ''){
            newkeep = that.keykeep
          }else{
            newkeep = keepstr
          }
          that.keyfilter = newfilter
          that.keykeep = newkeep
          callback()
        },
        error: function(response) {
          console.log('getBaseInfo', response)
        }
      })
    },

    /**
     * 获取数据
     */
    getTableList: function(stype){
      let that = this
      let url = that.API_URL + '/sys/match/list'
      that.query.type = stype
      that.query.filter = that.keyfilter.length > 1 ? that.keyfilter.join('|') : that.keyfilter.toString()
      that.query.keep = that.keykeep
      //that.query.keep = that.keykeep.length > 1 ? that.keykeep.join('|') : that.keykeep.toString()
      let query = that.query
      that.loading = true
      that.tablelist = []
      $.ajax({
        url: url,
        type: "POST",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: query,
        success: function(data) {
          console.log('getTableList', data)
          that.totalbrand = data.results[0][0].Count
          let lists = data.results[1]
          that.highlightkeywords = that.keyfilter
          lists.forEach(item => {
            item.AssetTitle = that.highlighted(that.highlightkeywords, item.AssetTitle)
            item.SkuMap = that.highlighted(that.highlightkeywords, item.SkuMap)
          })
          that.tablelist = lists
          that.loading = false
        },
        error: function(response) {
          console.log('getTableList', response)
        }
      })
    },

    /**
     * 保存过滤规则
     */
    saveFilterKeywords: function(){
      let that = this
      let url = that.API_URL + '/sys/match/edit'
      let query = {
        subid: that.query.subid,
        keep: that.keykeep,
        //keep: that.keykeep.length > 1 ? that.keykeep.join('|') : that.keykeep.length === 1 ? that.keykeep.toString() : '',
        filter: that.keyfilter.length > 1 ? that.keyfilter.join('|') : that.keyfilter.length === 1 ? that.keyfilter.toString() : ''
      }
      console.log(query)
      $.ajax({
        url: url,
        type: "PUT",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: query,
        success: function(data) {
          console.log('saveFilterKeywords', data)
          that.getBaseInfo(function(){
            that.getTableList(that.query.type)
          })
        },
        error: function(response) {
          console.log('saveFilterKeywords', response)
        }
      })
    },

    /**
     * 去除空格
     */
    trimTags: function(obj){
      return $.trim(obj)
    },

    /**
     * 命中未命中
     */
    hitData: function(t){
      this.query.page = 1
      this.currentPage = 1
      if(t == 0){
        this.isplain0 = false
        this.isplain1 = true
      }
      if(t == 1){
        this.isplain0 = true
        this.isplain1 = false
      }
      this.getTableList(t)
    },

    /**
     * 清除杂质
     */
    deleteNoise: function(){
      let that = this
      let url = that.API_URL + '/sys/match/del'
      let query = {subid: that.query.subid, assetidlist: that.chklists}
      console.log('deleteNoise', query)
      $.ajax({
        url: url,
        type: "PUT",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: query,
        success: function(data) {
          console.log('deleteNoise', data)
          that.getTableList(that.query.type)
        },
        error: function(response) {
          console.log('deleteNoise', response)
        }
      })      
    },

    /**
     * Price 排序
     */
    sortthiscolumn: function(column){
      let that = this
      if(column.prop == "Price" && column.order == "ascending"){
        that.query.order = 10
        that.getBaseInfo(function(){
          that.getTableList(that.query.type)
        })
        this.setLocalStorage('OrderFilter', 10)
      }else if(column.prop == "Price" && column.order == "descending"){
        that.query.order = 11
        that.getBaseInfo(function(){
          that.getTableList(that.query.type)
        })
        that.setLocalStorage('OrderFilter', 11)
      }else if(column.prop == "Price" && column.order == null){
        that.query.order = ''
        that.getBaseInfo(function(){
          that.getTableList(that.query.type)
        })
        that.setLocalStorage('OrderFilter', '')
      }else{
        return
      }
    },

    /**
     * 清除全部杂质
     */
    deleteAllNoise: function(){
      let that = this
      let url = that.API_URL + '/sys/match/delAll'
      that.query.type = 1
      that.query.filter = that.keyfilter.length > 1 ? that.keyfilter.join('|') : that.keyfilter.toString()
      that.query.keep = that.keykeep
      let query = {
        subid: that.$route.params.subid,
        filter: that.query.filter,
        keep: that.query.keep,
        type: 1,
        order: ''        
      }
      $.ajax({
        url: url,
        type: "POST",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: query,
        success: function(data) {
          console.log('deleteAllNoise', data)
          that.$message.success('修改成功')
          that.getBaseInfo(function(){
            that.getTableList(that.query.type)
          })          
        },
        error: function(response) {
          console.log('deleteAllNoise', response)
        }
      })
    },

  }
};
</script>